import { makeStyles } from "tss-react/mui"
import { TooltipType } from "./Tooltip"
import { blueGrey } from "@mui/material/colors"
import { tooltipClasses } from "@mui/material"
import { alpha } from "@mui/system"

export type StylesParams = {
  arrowEnabled: boolean
}

export type StylesProperties = "tooltip" | "label" | "data" | "sm" | "md" | "lg"

export const useStyles = makeStyles<StylesParams, StylesProperties>()(
  (
    { spacing, typography, palette, shadows },
    { arrowEnabled = false },
    classes
  ) => ({
    tooltip: {
      margin: arrowEnabled
        ? "0.25rem 0.125rem !important"
        : "0.125rem !important",
      fontSize: typography.pxToRem(12),
      lineHeight: typography.pxToRem(14)
    },
    label: {
      backgroundColor: alpha(blueGrey[900], 0.75),
      color: palette.common.white,
      border: "unset",
      [`.${tooltipClasses.arrow}:before`]: {
        backgroundColor: alpha(blueGrey[900], 0.75),
        border: "unset"
      }
    },
    data: {
      backgroundColor: palette.background.paper,
      color: palette.text.primary,
      border: `1px solid ${blueGrey[100]}`,
      boxShadow: shadows[6],
      [`.${tooltipClasses.arrow}:before`]: {
        backgroundColor: palette.common.white,
        border: `1px solid ${blueGrey[100]}`
      },

      [`&.${classes.sm}`]: {
        padding: spacing(2),
        fontSize: typography.pxToRem(11)
      },
      [`&.${classes.md}`]: {
        padding: spacing(2)
      },
      [`&.${classes.lg}`]: {
        padding: spacing(3)
      }
    },
    // tooltip sizes (default)
    sm: {
      padding: spacing(1)
    },
    md: {
      padding: spacing(1, 2)
    },
    lg: {
      padding: spacing(2),
      fontSize: typography.pxToRem(14),
      lineHeight: typography.pxToRem(18)
    }
  })
)
